import { axiosInstance } from "../utils/axios";
import { getAuthHeader } from "../utils/authTools";

export const uploadMedia = async (request) => {
    let response = await axiosInstance.post(
        `/upload`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const getuploadMedia = async (request) => {
    let response = await axiosInstance.get(
        `/upload/all?${request}`,
        getAuthHeader()
    );
    return response.data;
};

export const getUploadDetailByID = async (request) => {
    let response = await axiosInstance.get(
        `/upload/${request}`,
        getAuthHeader()
    );
    return response.data;
};

export const deleteuploadMedia = async (request) => {
    let response = await axiosInstance.delete(
        `/upload/${request}`,
        getAuthHeader()
    );
    return response.data;
};

export const highlightUpload = async (request) => {
    let response = await axiosInstance.patch(
        `/upload/highlight/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const editUpload = async (request) => {
    let response = await axiosInstance.patch(
        `/upload/edit/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};